import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Input,
  Label,
  Button,
  Badge,
  Card,
  CardBody,
} from "reactstrap";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import DragAndDropComponent from "components/FileUploadDrag/DragAndDrop";
import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import secureLocalStorage from "react-secure-storage";
import { post } from "helpers/api_helper";
import * as api from "../../constants/api_constants";
import { useNavigate, useParams } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import {
  getAllCountries,
  getStatesForCountry,
  getCitiesForState,
} from "helpers/utils/locationUtil";

const AddNewCandidate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log("jobId", id);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [techSkills, setTechSkills] = useState([]);
  const [softSkills, setSoftSkills] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedTech, setSelectedTech] = useState("");
  const [selectedSoft, setSelectedSoft] = useState("");
  const [selectedLang, setSelectedLang] = useState("");
  const [uploadedDocs, setUploadedDocs] = useState({
    resume: {},
    coverLetter: {},
    passport: {},
    workAuthorizationVisa: {},
    academinCertificates: {},
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // console.log("uploadedDocs", uploadedDocs);

  const storedUser = secureLocalStorage.getItem("authUser");
  const user = JSON.parse(storedUser);
  const updatedDate = new Date().toISOString();

  const validationSchema = Yup.object().shape({
    // firstName: Yup.string().required("First Name is required"),
    // lastName: Yup.string().required("Last Name is required"),
    // email: Yup.string().email("Invalid email").required("Email is required"),
    // mobileNumber: Yup.string()
    //   .required("Mobile Number is required")
    //   .required("Primary contact phone is required")
    //   .test(
    //     "isValidPhone",
    //     "Invalid phone number format",
    //     (value) => !value || isValidPhoneNumber(value)
    //   )
    //   .test(
    //     "startsWithSixOrHigher",
    //     "Phone number must start with 6, 7, 8, or 9",
    //     (value) => {
    //       if (!value) return true;
    //       // Remove all non-digit characters
    //       const digitsOnly = value.replace(/\D/g, "");
    //       // Remove country code "91" if it exists at the start
    //       const localNumber = digitsOnly.startsWith("91")
    //         ? digitsOnly.slice(2)
    //         : digitsOnly;
    //       // Now check if it starts with 6-9 and has 10 digits
    //       return /^[6-9]\d{9}$/.test(localNumber);
    //     }
    //   ),
    // dob: Yup.string().required("Date of Birth is required"),
    // gender: Yup.string().required("Gender is required"),
    // state: Yup.string().required("Province/State is required"),
    // city: Yup.string().required("City is required"),
    // zipcode: Yup.string().required("Zipcode is required"),
    // address: Yup.string().required("Complete Address is required"),
    // totalExperience: Yup.string().required("Total Experience is required"),
    // currentJobTitle: Yup.string().required("Current Job Title is required"),
    // linkedIn: Yup.string()
    //   .url("Must be a valid URL")
    //   .required("LinkedIn is required"),
    // techSkills: Yup.array().min(1, "At least one technical skill is required"),
    // softSkills: Yup.array().min(1, "At least one soft skill is required"),
    // languages: Yup.array().min(1, "At least one language is required"),
    // // resume: Yup.mixed().required("Resume is required"),
    // gitHub: Yup.string().url("Must be a valid URL").nullable(),
    // portfolio: Yup.string().url("Must be a valid URL").nullable(),
    // pan: Yup.string()
    //   .matches(
    //     /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    //     "Invalid PAN format (e.g., ABCDE1234F)"
    //   )
    //   .nullable(),
    // aadhar: Yup.string()
    //   .matches(/^\d{12}$/, "Invalid Aadhar format (12 digits)")
    //   .nullable(),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      mobileNumber: "",
      alternateContact: "",
      dob: "",
      gender: "",
      maritalStatus: "",
      country: "",
      province: "",
      city: "",
      zipcode: "",
      address: "",
      totalExperience: "",
      currentJobTitle: "",
      currentEmployer: "",
      currentCTC: "",
      expectedCTC: "",
      noticePeriod: "",
      relocate: "",
      remoteWork: "",
      jobType: [],
      linkedIn: "",
      gitHub: "",
      portfolio: "",
      degree: "",
      specialization: "",
      passingYear: "",
      institute: "",
      eduCountry: "",
      grade: "",
      techSkills: [],
      softSkills: [],
      languages: [],
      pan: "",
      aadhar: "",
      passportNumber: "",
      travelAbroad: "",
      workedAbroad: "",
      workedCountry: "",
      companyName: "",
      careerGap: "",
      gapMonths: "",
      gapReason: "",
      source: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const confirmSubmit = window.confirm(
        "Are you sure you want to submit this form?"
      );
      if (!confirmSubmit) {
        showErrorToast("Submission cancelled");
        return; // ❌ stop submission
      }
      const payload = {
        generalInfoCandidateDto: {
          candiRefId: 1, // Adjust if dynamic
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          mobileNumber: values.mobileNumber,
          alternativeContactNumber: values.alternateContact,
          dateOfBirth: values.dob,
          gender: values.gender,
          maritalStatus: values.maritalStatus,
          nationality: values.country,
          province: values.state,
          city: values.city,
          zipcode: values.zipcode,
          completeAddress: values.address,
        },
        professionalDetailsDto: {
          candiRefId: 1,
          totalExperience: parseInt(values.totalExperience) || 0,
          currentJobTitle: values.currentJobTitle,
          currentEmployer: values.currentEmployer,
          currentCtc: values.currentCTC,
          expectedCtc: values.expectedCTC,
          noticePeriod: values.noticePeriod,
          openToRelocate: values.relocate,
          openToWorkRemotely: values.remoteWork,
          preferredJobType: values.jobType.join(", "),
          linkedin: values.linkedIn,
          github: values.gitHub,
          portfolioAndWebsiteUrl: values.portfolio,
        },
        educationalDetailsDto: {
          candiRefId: 1,
          highestDegree: values.degree,
          specilalization: values.specialization, // Fix typo: should be 'specialization'
          yearOfPassing: values.passingYear,
          instituteName: values.institute,
          country: values.eduCountry,
          gradePercentageCgpa: values.grade,
        },
        skillsCertificationDto: {
          candiRefId: 1,
          keyTechnicalSkills: values.techSkills,
          softSkills: values.softSkills,
          languagesKnown: values.languages,
        },
        resumeSupportingDocDto: {
          candiRefId: 1,
          uploadResume: uploadedDocs.resume?.id || "", // Use uploadedDocs
          uploadCoverLetter: uploadedDocs.coverLetter?.id || "",
          uploadPassportCopy: uploadedDocs.passport?.id || "",
          uploadWorkAuthorizationVisa:
            uploadedDocs.workAuthorizationVisa?.id || "",
          uploadAcademicCertificates:
            uploadedDocs.academinCertificates?.id || "",
        },
        additionalDetailsDto: {
          candiRefId: 1,
          panNumber: values.pan,
          aadharNumber: values.aadhar,
          passportNumber: values.passportNumber,
          WillingToTravelAbroad: values.travelAbroad,
          haveYouEverWorkedAbroad: values.workedAbroad,
          countryWorked: values.workedCountry,
          nameOfTheCompany: values.companyName,
          anyGapsInCareer: values.careerGap,
          noOfMonthsWithGap: values.gapMonths,
          selectAReasonGap: values.gapReason,
        },
        othersDto: {
          candiRefId: 1,
          source: values.source,
          internalEmployeeId: user?.employeeId || "", // Use user data if available
        },
        delFlag: 1,
      };
      console.log("pay", payload);

      try {
        // Step 1: Create the candidate
        const response = await post(api.CREATE_CANDIDATE_POST, payload);
        console.log("Candidate created successfully:", response.data);

        // Step 2: Apply candidate to the job if creation was successful
        if (response.data.id) {
          const applyPayload = {
            candidateId: [response.data.id],
            jobId: parseInt(id), // Use the jobId from useParams
          };
          console.log("Apply payload:", applyPayload);

          const responseApply = await post(
            api.CANDIDATE_APPLY_FOR_JOB,
            applyPayload
          );
          console.log("Apply response:", responseApply);

          // Show success message
          showSuccessToast("Candidate created and applied to job successfully");
        } else {
          console.error("Candidate creation did not return an ID");
          showSuccessToast(
            "Candidate created, but failed to apply to job",
            "error"
          );
        }

        // Step 3: Navigate back to JobDetails
        navigate(`/job-details/${id}`);
      } catch (error) {
        console.error(
          "Error creating candidate:",
          error.response?.data || error.message
        );
        showErrorToast("Failed to create candidate", "error");
      }
    },
  });

  const handleFileUpload = (response, documentType) => {
    setUploadedDocs((prev) => ({
      ...prev,
      [documentType]: response,
    }));
    if (documentType === "resume") {
      formik.setFieldValue("resume", response);
    }
  };

  const techOptions = ["HTML", "CSS", "React", "JavaScript"];
  const softOptions = [
    "Teamwork",
    "Problem Solving",
    "Communication",
    "Active Listener",
  ];
  const languageOptions = ["English", "Telugu", "Hindi", "Tamil"];

  const handleAdd = (value, setValue, list, setList, fieldName) => {
    if (value && !list.includes(value)) {
      const updatedList = [...list, value];
      setList(updatedList);
      formik.setFieldValue(fieldName, updatedList); // Update Formik field
    }
    setValue("");
  };

  const handleRemove = (item, list, setList, fieldName) => {
    const updatedList = list.filter((i) => i !== item);
    setList(updatedList);
    formik.setFieldValue(fieldName, updatedList); // Update Formik field
  };

  // Location handling
  useEffect(() => {
    const fetchedCountries = getAllCountries();
    setCountries(fetchedCountries);
  }, []);

  useEffect(() => {
    if (formik.values.country) {
      const fetchedStates = getStatesForCountry(formik.values.country);
      setStates(fetchedStates);
      formik.setFieldValue("state", "");
      formik.setFieldValue("city", "");
    }
  }, [formik.values.country]);

  useEffect(() => {
    if (formik.values.state) {
      const fetchedCities = getCitiesForState(
        formik.values.country,
        formik.values.state
      );
      setCities(fetchedCities);
      formik.setFieldValue("city", "");
    }
  }, [formik.values.state, formik.values.country]);

  return (
    <div className="page-content">
      <PageSubHeader
        heading="Add New Candidate"
        routePath="Home"
        pageName="Job Postings / JD1023 / Add New Candidate"
      />
      <Container fluid className="py-4 px-5">
        <form onSubmit={formik.handleSubmit}>
          {/* 01 - General Information */}
          <Row className="heading mt-3 pe-4">
            <p className="sub-head">01 - General</p>
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="firstName">
                  First Name
                </Label>
                <Input
                  type="text"
                  name="firstName"
                  id="firstName"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="First Name"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.firstName && formik.errors.firstName ? (
                  <div className="text-danger text-sm">
                    {formik.errors.firstName}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="lastName">
                  Last Name
                </Label>
                <Input
                  type="text"
                  name="lastName"
                  id="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Last Name"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.lastName && formik.errors.lastName ? (
                  <div className="text-danger text-sm">
                    {formik.errors.lastName}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="email">
                  Email
                </Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Email"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-danger text-sm">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="mobileNumber">
                  Mobile Number
                </Label>
                <Input
                  type="text"
                  name="mobileNumber"
                  id="mobileNumber"
                  value={formik.values.mobileNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Mobile Number"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.mobileNumber && formik.errors.mobileNumber ? (
                  <div className="text-danger text-sm">
                    {formik.errors.mobileNumber}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="alternateContact">
                  Alternate Contact Number
                </Label>
                <Input
                  type="text"
                  name="alternateContact"
                  id="alternateContact"
                  value={formik.values.alternateContact}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Mobile Number"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="dob">
                  Date of Birth
                </Label>
                <Input
                  type="date"
                  name="dob"
                  id="dob"
                  value={formik.values.dob}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="DD-MM-YYYY"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.dob && formik.errors.dob ? (
                  <div className="text-danger text-sm">{formik.errors.dob}</div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="gender">
                  Gender
                </Label>
                <Input
                  type="select"
                  name="gender"
                  id="gender"
                  value={formik.values.gender}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </Input>
                {formik.touched.gender && formik.errors.gender ? (
                  <div className="text-danger text-sm">
                    {formik.errors.gender}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="maritalStatus">
                  Marital Status
                </Label>
                <Input
                  type="select"
                  name="maritalStatus"
                  id="maritalStatus"
                  value={formik.values.maritalStatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>Single</option>
                  <option>Married</option>
                </Input>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="country">
                  Country
                </Label>
                <Input
                  type="select"
                  name="country"
                  id="country"
                  value={formik.values.country}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  {countries.map((country) => (
                    <option key={country.value} value={country.value}>
                      {country.label}
                    </option>
                  ))}
                </Input>
                {formik.touched.country && formik.errors.country ? (
                  <div className="text-danger text-sm">
                    {formik.errors.country}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="state">
                  Province/State
                </Label>
                <Input
                  type="select"
                  name="state"
                  id="state"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  {states.map((state) => (
                    <option key={state.value} value={state.value}>
                      {state.label}
                    </option>
                  ))}
                </Input>
                {formik.touched.state && formik.errors.state ? (
                  <div className="text-danger text-sm">
                    {formik.errors.state}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="city">
                  City
                </Label>
                <Input
                  type="select"
                  name="city"
                  id="city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  {cities.map((city) => (
                    <option key={city.value} value={city.value}>
                      {city.label}
                    </option>
                  ))}
                </Input>
                {formik.touched.city && formik.errors.city ? (
                  <div className="text-danger text-sm">
                    {formik.errors.city}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="zipcode">
                  Zipcode
                </Label>
                <Input
                  type="text"
                  name="zipcode"
                  id="zipcode"
                  value={formik.values.zipcode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Zipcode"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.zipcode && formik.errors.zipcode ? (
                  <div className="text-danger text-sm">
                    {formik.errors.zipcode}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={12}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="address">
                  Address
                </Label>
                <Input
                  type="textarea"
                  name="address"
                  id="address"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Address"
                  className="rounded-md border-gray-300"
                  rows={5}
                />
                {formik.touched.address && formik.errors.address ? (
                  <div className="text-danger text-sm">
                    {formik.errors.address}
                  </div>
                ) : null}
              </div>
            </Col>
          </Row>

          {/* 02 - Professional Details */}
          <Row className="heading mt-3 pe-4">
            <p className="sub-head">02 - Professional Details</p>
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="totalExperience">
                  Total Experience
                </Label>
                <Input
                  type="select"
                  name="totalExperience"
                  id="totalExperience"
                  value={formik.values.totalExperience}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select Experience</option>
                  {[...Array(31)].map((_, i) => (
                    <option key={i}>{i}</option>
                  ))}
                </Input>
                {formik.touched.totalExperience &&
                formik.errors.totalExperience ? (
                  <div className="text-danger text-sm">
                    {formik.errors.totalExperience}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="currentJobTitle">
                  Current Job Title
                </Label>
                <Input
                  name="currentJobTitle"
                  id="currentJobTitle"
                  value={formik.values.currentJobTitle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Job Title"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.currentJobTitle &&
                formik.errors.currentJobTitle ? (
                  <div className="text-danger text-sm">
                    {formik.errors.currentJobTitle}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="currentEmployer">
                  Current Employer
                </Label>
                <Input
                  name="currentEmployer"
                  id="currentEmployer"
                  value={formik.values.currentEmployer}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Current Employer"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="currentCTC">
                  Current CTC
                </Label>
                <Input
                  name="currentCTC"
                  id="currentCTC"
                  value={formik.values.currentCTC}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Current CTC"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="expectedCTC">
                  Expected CTC
                </Label>
                <Input
                  name="expectedCTC"
                  id="expectedCTC"
                  value={formik.values.expectedCTC}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Expected CTC"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="noticePeriod">
                  Notice Period
                </Label>
                <Input
                  name="noticePeriod"
                  id="noticePeriod"
                  value={formik.values.noticePeriod}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Notice Period"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="relocate">
                  Open to Relocate
                </Label>
                <Input
                  type="select"
                  name="relocate"
                  id="relocate"
                  value={formik.values.relocate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </Input>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="remoteWork">
                  Open to Work Remotely
                </Label>
                <Input
                  type="select"
                  name="remoteWork"
                  id="remoteWork"
                  value={formik.values.remoteWork}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </Input>
              </div>
            </Col>
          </Row>
          <div className="mb-4">
            <Label className="form-label">Preferred Job Type</Label>
            <div className="d-flex gap-2">
              {["Full Time", "Part Time", "Contract", "Internship"].map(
                (type) => (
                  <div className="d-flex gap-2" key={type}>
                    <Label className="form-label">
                      <Input
                        type="checkbox"
                        name="jobType"
                        value={type}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="checkbox me-2"
                        style={{ border: "1px solid #475467" }}
                      />
                      {type}
                    </Label>
                  </div>
                )
              )}
            </div>
          </div>
          <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="linkedIn">
                  LinkedIn
                </Label>
                <Input
                  name="linkedIn"
                  id="linkedIn"
                  value={formik.values.linkedIn}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="LinkedIn"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.linkedIn && formik.errors.linkedIn ? (
                  <div className="text-danger text-sm">
                    {formik.errors.linkedIn}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="gitHub">
                  GitHub
                </Label>
                <Input
                  name="gitHub"
                  id="gitHub"
                  value={formik.values.gitHub}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="GitHub"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.gitHub && formik.errors.gitHub ? (
                  <div className="text-danger text-sm">
                    {formik.errors.gitHub}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="portfolio">
                  Portfolio/Website URL
                </Label>
                <Input
                  name="portfolio"
                  id="portfolio"
                  value={formik.values.portfolio}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Portfolio/Website"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.portfolio && formik.errors.portfolio ? (
                  <div className="text-danger text-sm">
                    {formik.errors.portfolio}
                  </div>
                ) : null}
              </div>
            </Col>
          </Row>

          {/* 03 - Educational Details */}
          <Row className="heading mt-3 pe-4">
            <p className="sub-head">03 - Educational Details</p>
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="degree">
                  Highest Degree
                </Label>
                <Input
                  type="select"
                  name="degree"
                  id="degree"
                  value={formik.values.degree}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select Degree</option>
                  <option>B.Tech</option>
                  <option>M.Tech</option>
                  <option>B.Sc</option>
                  <option>MBA</option>
                  <option>M.sc</option>
                  <option>Other</option>
                </Input>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="specialization">
                  Specialization
                </Label>
                <Input
                  name="specialization"
                  id="specialization"
                  value={formik.values.specialization}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Specialization"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="passingYear">
                  Year Of Passing
                </Label>
                <Input
                  name="passingYear"
                  id="passingYear"
                  value={formik.values.passingYear}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Year Of Passing"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="institute">
                  Institute Name
                </Label>
                <Input
                  name="institute"
                  id="institute"
                  value={formik.values.institute}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Institute Name"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="eduCountry">
                  Country
                </Label>
                <Input
                  type="select"
                  name="eduCountry"
                  id="eduCountry"
                  value={formik.values.eduCountry}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>India</option>
                  <option>Other</option>
                </Input>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="grade">
                  Grade/Percentage/CGPA
                </Label>
                <Input
                  name="grade"
                  id="grade"
                  value={formik.values.grade}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Grade/Percentage/CGPA"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
          </Row>

          {/* 04 - Skills & Certifications */}
          <Row className="heading mt-3 pe-4">
            <p className="sub-head">04 - Skills & Certifications</p>
          </Row>
          <Row>
            <Col md={4} className="mb-4">
              <Label className="form-label" htmlFor="techSkills">
                Key Technical Skills (separate buy comma)
              </Label>
              <Input
                type="text"
                id="techSkills"
                placeholder="Type a skill and press comma"
                value={selectedTech}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.endsWith(",")) {
                    handleAdd(
                      value.slice(0, -1),
                      setSelectedTech,
                      techSkills,
                      setTechSkills,
                      "techSkills"
                    );
                    setSelectedTech("");
                  } else {
                    setSelectedTech(value);
                  }
                }}
                onBlur={() => formik.setFieldTouched("techSkills", true)}
                className="rounded-md border-gray-300"
              />
              <div className="mt-2 flex flex-wrap gap-2">
                {techSkills.map((skill) => (
                  <Badge
                    key={skill}
                    color="primary"
                    className="me-1 mb-2 px-3 py-1"
                  >
                    {skill}
                    <Button
                      close
                      onClick={() =>
                        handleRemove(
                          skill,
                          techSkills,
                          setTechSkills,
                          "techSkills"
                        )
                      }
                      className="ms-2 p-0"
                      style={{ fontSize: "0.7rem" }}
                    />
                  </Badge>
                ))}
              </div>
              {formik.touched.techSkills && formik.errors.techSkills ? (
                <div className="text-danger text-sm mt-1">
                  {formik.errors.techSkills}
                </div>
              ) : null}
            </Col>
          </Row>

          <Row>
            <Col md={4} className="mb-4">
              <Label className="form-label" htmlFor="softSkills">
                Soft Skills (separate buy comma)
              </Label>
              <Input
                type="text"
                id="softSkills"
                placeholder="Type a skill and press comma"
                value={selectedSoft}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.endsWith(",")) {
                    handleAdd(
                      value.slice(0, -1),
                      setSelectedSoft,
                      softSkills,
                      setSoftSkills,
                      "softSkills"
                    );
                    setSelectedSoft("");
                  } else {
                    setSelectedSoft(value);
                  }
                }}
                onBlur={() => formik.setFieldTouched("softSkills", true)}
                className="rounded-md border-gray-300"
              />
              <div className="mt-2 flex flex-wrap gap-2">
                {softSkills.map((skill) => (
                  <Badge
                    key={skill}
                    color="primary"
                    className="me-1 mb-2 px-3 py-1"
                  >
                    {skill}
                    <Button
                      close
                      onClick={() =>
                        handleRemove(
                          skill,
                          softSkills,
                          setSoftSkills,
                          "softSkills"
                        )
                      }
                      className="ms-2 p-0"
                      style={{ fontSize: "0.7rem" }}
                    />
                  </Badge>
                ))}
              </div>
              {formik.touched.softSkills && formik.errors.softSkills ? (
                <div className="text-danger text-sm mt-1">
                  {formik.errors.softSkills}
                </div>
              ) : null}
            </Col>
          </Row>

          {/* <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="languages">
                  Languages Known 
                </Label>
                <Input
                  type="select"
                  id="languages"
                  value={selectedLang}
                  onChange={(e) =>
                    handleAdd(
                      e.target.value,
                      setSelectedLang,
                      languages,
                      setLanguages,
                      "languages"
                    )
                  }
                  onBlur={() => formik.setFieldTouched("languages", true)}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  {languageOptions.map((lang) => (
                    <option key={lang} value={lang}>
                      {lang}
                    </option>
                  ))}
                </Input>
                <div className="mt-2 flex flex-wrap gap-2">
                  {languages.map((lang) => (
                    <Badge
                      key={lang}
                      color="primary"
                      className="me-1 mb-2 px-3 py-1"
                    >
                      {lang}
                      <Button
                        close
                        onClick={() =>
                          handleRemove(
                            lang,
                            languages,
                            setLanguages,
                            "languages"
                          )
                        }
                      />
                    </Badge>
                  ))}
                </div>
                {formik.touched.languages && formik.errors.languages ? (
                  <div className="text-danger text-sm">
                    {formik.errors.languages}
                  </div>
                ) : null}
              </div>
            </Col>
          </Row> */}

          {/* 05 - Resume & Supporting Documents */}
          <Row className="heading mt-3 pe-4">
            <p className="sub-head">05 - Resume & Supporting Documents</p>
          </Row>
          <Row>
            <Col md="4">
              <Label htmlFor="contactMobile">Upload Resume (PDF/DOC)</Label>
              <DragAndDropComponent
                initialFile={uploadedDocs.resume}
                handleFileUpload={(response) =>
                  handleFileUpload(response, "resume")
                }
              />
              {/* {formik.touched.resume && formik.errors.resume ? (
                <div className="text-danger text-sm">
                  {formik.errors.resume}
                </div>

              ) : null} */}
            </Col>
            <Col md="4">
              <Label htmlFor="contactMobile">
                Upload Cover Letter (Optional)
              </Label>
              <DragAndDropComponent
                initialFile={uploadedDocs.coverLetter}
                handleFileUpload={(response) =>
                  handleFileUpload(response, "coverLetter")
                }
              />
            </Col>
            <Col md="4">
              <Label htmlFor="contactMobile">
                Upload Passport Copy (for foreign hiring if applicable)
              </Label>
              <DragAndDropComponent
                initialFile={uploadedDocs.passport}
                handleFileUpload={(response) =>
                  handleFileUpload(response, "passport")
                }
              />
            </Col>
            <Col md="4">
              <Label htmlFor="contactMobile">
                Upload Work Authorization/Visa (if applicable)
              </Label>
              <DragAndDropComponent
                initialFile={uploadedDocs.workAuthorizationVisa}
                handleFileUpload={(response) =>
                  handleFileUpload(response, "workAuthorizationVisa")
                }
              />
            </Col>
            <Col md="4">
              <Label htmlFor="contactMobile">
                Upload Academic Certificates (Optional)
              </Label>
              <DragAndDropComponent
                initialFile={uploadedDocs.academinCertificates}
                handleFileUpload={(response) =>
                  handleFileUpload(response, "academinCertificates")
                }
              />
            </Col>
          </Row>

          {/* 06 - Additional Details */}
          <Row className="heading mt-3 pe-4">
            <p className="sub-head">06 - Additional Details</p>
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="pan">
                  PAN Number
                </Label>
                <Input
                  name="pan"
                  id="pan"
                  value={formik.values.pan}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="PAN Number"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.pan && formik.errors.pan ? (
                  <div className="text-danger text-sm">{formik.errors.pan}</div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="aadhar">
                  Aadhar Number
                </Label>
                <Input
                  name="aadhar"
                  id="aadhar"
                  value={formik.values.aadhar}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Aadhar Number"
                  className="rounded-md border-gray-300"
                />
                {formik.touched.aadhar && formik.errors.aadhar ? (
                  <div className="text-danger text-sm">
                    {formik.errors.aadhar}
                  </div>
                ) : null}
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="passportNumber">
                  Passport Number (For International jobs)
                </Label>
                <Input
                  name="passportNumber"
                  id="passportNumber"
                  value={formik.values.passportNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Passport Number"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="travelAbroad">
                  Willing to Travel Abroad?
                </Label>
                <Input
                  type="select"
                  name="travelAbroad"
                  id="travelAbroad"
                  value={formik.values.travelAbroad}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </Input>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="workedAbroad">
                  Have You Ever Worked Abroad?
                </Label>
                <Input
                  type="select"
                  name="workedAbroad"
                  id="workedAbroad"
                  value={formik.values.workedAbroad}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </Input>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="workedCountry">
                  Country Worked
                </Label>
                <Input
                  type="select"
                  name="workedCountry"
                  id="workedCountry"
                  value={formik.values.workedCountry}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option>India</option>
                  <option>Other</option>
                </Input>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="companyName">
                  Name of The Company
                </Label>
                <Input
                  name="companyName"
                  id="companyName"
                  value={formik.values.companyName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Company"
                  className="rounded-md border-gray-300"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-4">
                <Label className="form-label" htmlFor="careerGap">
                  Any Gaps in Career?
                </Label>
                <Input
                  type="select"
                  name="careerGap"
                  id="careerGap"
                  value={formik.values.careerGap}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="rounded-md border-gray-300"
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Input>
              </div>
            </Col>

            {formik.values.careerGap === "Yes" && (
              <>
                <Col md={4}>
                  <div className="mb-4">
                    <Label className="form-label" htmlFor="gapMonths">
                      No. Of Months With Gap
                    </Label>
                    <Input
                      name="gapMonths"
                      id="gapMonths"
                      value={formik.values.gapMonths}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="No. Of Months With Gap"
                      className="rounded-md border-gray-300"
                    />
                  </div>
                </Col>

                <Col md={4}>
                  <div className="mb-4">
                    <Label className="form-label" htmlFor="gapReason">
                      Select a Reason For Gap
                    </Label>
                    <Input
                      type="select"
                      name="gapReason"
                      id="gapReason"
                      value={formik.values.gapReason}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="rounded-md border-gray-300"
                    >
                      <option value="">Select</option>
                      <option value="education">Further Education</option>
                      <option value="family_care">Family Care</option>
                      <option value="job_search">Job Searching</option>
                      <option value="travel">Other</option>
                    </Input>
                  </div>
                </Col>
              </>
            )}
          </Row>

          <Row className="mt-4">
            <Col className="gap-2 d-flex justify-content-end">
              <Button
                className="text-primary border-primary"
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#475467",
                  borderRadius: "6px",
                  border: "1px solid #475467",
                }}
                disabled={isSubmitting} // ✅ Disable during submission
              >
                Cancel
              </Button>
              <CustomButton
                text={isSubmitting ? "Submitting..." : "Submit"}
                type="submit"
                disabled={isSubmitting} // ✅ Disable during submission
              />
            </Col>
          </Row>
        </form>
      </Container>
    </div>
  );
};

export default AddNewCandidate;
